import axiosInstanceWithoutInterceptor from "../axiosWithoutInterceptor";
import getConfig from "../config";

const { appEnv, hostnames } = getConfig();
const { dataService } = hostnames;
const FEATURE_FLAG_API = `${dataService}/api/v1/features`;

export async function getFeatureFlags(spec) {
    const specEnv = appEnv === "local" ? "dev" : appEnv;
    const configName = `${spec}.${specEnv}`;

    try {
        const { data } = await axiosInstanceWithoutInterceptor({
            method: "post",
            url: FEATURE_FLAG_API,
            baseURL: null,
            data: { config: { names: [configName] } },
            timeout: 5000, // Kill request after 5 seconds
        });

        if (Object.keys(data?.data || {}).length === 0 && data?.error) {
            // eslint-disable-next-line no-console
            console.error("Error fetching feature flags:", {
                error: data?.error,
                spec,
                specEnv,
                configName,
            });
        }

        return data?.data || {};
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching feature flags:", {
            error: error,
            spec,
            specEnv,
            configName,
            status: error?.response?.status,
            url: error?.config?.url,
        });
        return {};
    }
}
